<template>
  <div :is="tag" :class="[getSlideClass, {open:isOpen}]" @click="toggleDropDown" v-click-outside="closeDropDown">
    <slot name="title">
      <a class="dropdown-toggle btn-rotate user-dropdown" data-toggle="dropdown" href="javascript:void(0)" style="">
        <i :class="icon"></i>
        <p class="notification"><span :class="{'btn btn-fill btn-danger': alert}">{{title}}</span>
          <br v-if="subtitle" />{{subtitle}}</p>
        <b class="caret"></b>
      </a>
    </slot>
    <ul class="dropdown-menu">
      <slot></slot>
    </ul>
  </div>
</template>
<style>
  .user-dropdown {
    margin-top: 0 !important;
    margin-bottom: 0 !important; 
    position: relative !important; 
    top: 50% !important;
    height: 74px !important;
  }
  .notification {
    position: relative; 
    top: 50%; 
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
  }
  .caret {
    margin-left: 7px; 
    position: absolute; 
    top: 50%; 
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
  }
</style>
<script>
  export default{
    name: 'drop-down',
    props: {
      title: String,
      subtitle: String,
      alert: Boolean,
      icon: String,
      slide: {
        type: String,
        default: 'down'
      },
      tag: {
        type: String,
        default: 'div'
      }
    },
    computed: {
      getSlideClass () {
        return this.slide === 'down' ? 'dropdown' : 'dropup'
      }
    },
    data () {
      return {
        isOpen: false
      }
    },
    methods: {
      toggleDropDown () {
        this.isOpen = !this.isOpen
      },
      closeDropDown () {
        this.isOpen = false
      }
    }
  }
</script>
